export const message = {
    "教学团队":"教學團隊",
    "自己":"自己",
    "暂无成员":"暫無成員",
    "暂不支持给自己发送私信":"暫不支持給自己發送私信",
    "获取用户组失败组id为空":"獲取用戶組失敗组id為空",
    "查看聊天记录":"查看聊天記錄",
    "历史":"歷史",
    "获取用户ID失败":"獲取用戶ID失敗",
    "通讯录":"通訊錄",
    "通知":"通知",
    "查看旧版聊天记录":"查看舊版聊天記錄",
    "暂无消息":"暫無消息",
}
